import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBuilding, FaCog, FaBell, FaShieldAlt, FaPalette, FaBriefcase, FaChevronRight } from 'react-icons/fa';
import './SettingsDashboard.css';

function SettingsDashboard() {
  const location = useLocation();

  const propertyDashMatch = location.pathname.match(/\/propertydashboard\/(\d+)\/settings/);
  const propertyMatch = location.pathname.match(/\/properties\/(\d+)\/settings/);
  const id = propertyDashMatch?.[1] || propertyMatch?.[1];

  let basePath;
  if (propertyDashMatch) basePath = `/propertydashboard/${id}/settings`;
  else if (propertyMatch) basePath = `/properties/${id}/settings`;
  else basePath = '/settings';

  const items = [
    { icon: <FaBuilding />, color: '#1A80E5', bg: '#EBF5FF', title: 'Company Information', desc: 'Company details, logo, and contact information', link: `${basePath}/company` },
    { icon: <FaCog />, color: '#7c3aed', bg: '#f3f0ff', title: 'Application Settings', desc: 'Timezone, date format, and maintenance mode', link: `${basePath}/application` },
    { icon: <FaBell />, color: '#d97706', bg: '#fef9ee', title: 'Notification Settings', desc: 'Email and in-app notification preferences', link: `${basePath}/notifications` },
    { icon: <FaShieldAlt />, color: '#059669', bg: '#ecfdf5', title: 'Security Settings', desc: 'Passwords, 2FA, session controls, and access', link: `${basePath}/security` },
    { icon: <FaPalette />, color: '#7c3aed', bg: '#f3f0ff', title: 'Branding Settings', desc: 'Logo, colours, and branding appearance', link: `${basePath}/branding` },
    { icon: <FaBriefcase />, color: '#1A80E5', bg: '#EBF5FF', title: 'Management Company', desc: 'Facility management company assignment', link: `${basePath}/management` },
  ];

  return (
    <div className="stg-dash">
      <div className="stg-dash-header">
        <h1>Settings</h1>
        <p>Manage your property and application preferences</p>
      </div>
      <div className="stg-dash-list">
        {items.map(item => (
          <Link to={item.link} className="stg-dash-row" key={item.title}>
            <span className="stg-dash-row-icon" style={{ background: item.bg, color: item.color }}>
              {item.icon}
            </span>
            <div className="stg-dash-row-text">
              <span className="stg-dash-row-title">{item.title}</span>
              <span className="stg-dash-row-desc">{item.desc}</span>
            </div>
            <FaChevronRight className="stg-dash-row-arrow" />
          </Link>
        ))}
      </div>
    </div>
  );
}

export default SettingsDashboard;
